// /* eslint-disable */
// import React from "react";
// import styles from "./HorizontalProgressChart.module.css";

// const HorizontalProgressChart = ({ data }) => {
//   return (
//     <div className={styles.progresschart}>
//       {data.map((item, index) => {
//         const percent = Math.round((item.value / item.total) * 100);

//         return (
//           <div className={styles.progressrow} key={index}>
//             <div className={styles.progresslabel}>
//               {item.label}
//             </div>
//             <div className={styles.progressbarwrapper}>
//               <div className={styles.progressbarbg}>
//                 <div
//                   className={styles.progressbarfill}
//                   style={{
//                     width: `${percent}%`,
//                     backgroundColor: item.color
//                   }}
//                 />
//               </div>
//             </div>
//             <div className={styles.progressvalue}>
//               {item.value} / {item.total} FTE
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default HorizontalProgressChart;


// /* eslint-disable */
// import React from "react";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import { Bar } from "react-chartjs-2";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Tooltip,
//   Legend,
//   ChartDataLabels
// );

// const HorizontalProgressChart = ({
//   labels = [],
//   actualFTEs = [],
//   budgetedFTEs = [],
//   heightValues = 300
// }) => {
//   const data = {
//     labels,
//     datasets: [
//       actualFTEs,
//       budgetedFTEs
//       // {
//       //   label: "Planned",
//       //   data: actualFTEs,
//       //   backgroundColor: "#4CAF50",
//       // },
//       // {
//       //   label: "Actual",
//       //   data: budgetedFTEs,
//       //   backgroundColor: "#2196F3",
//       // },
//     ],
//   };

//   const options = {
//     responsive: true,
//     indexAxis: "y",
//     plugins: {
//       legend: {
//         position: "top",
//         labels: {
//           usePointStyle: true,
//           pointStyle: "circle",
//           boxWidth: 12,
//           boxHeight: 12,
//           padding: 14,
//           font: { size: 12 },
//         },
//       },
//       datalabels: {
//         color: "#ffffff",
//         anchor: "center",
//         align: "center",
//         font: {
//           weight: "bold",
//           size: 12,
//         },
//         formatter: (value) => value,
//       },
//     },
//     scales: {
//       x: {
//         beginAtZero: true,
//         ticks: {
//           display: false,
//         },
//         grid: {
//           display: false,
//         },
//       },
//       y: {
//         stacked: false,
//         // ticks: {
//         //   padding: 15,
//         // },
//       },
//     },

//   };

//   return (
//     <Bar data={data} options={options} height={heightValues} />
//     // <div style={{ height: "900px", width: "100%" }}>
//     //   <Bar data={data} options={options} height={200}/>
//     // </div>
//   );
// };

// export default HorizontalProgressChart;

// ####################### New code #########################

// /* eslint-disable */
// import React from "react";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import { Bar } from "react-chartjs-2";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Tooltip,
//   Legend,
//   ChartDataLabels
// );

// const HorizontalProgressChart = ({
//   labels = [],
//   actualFTEs = [],
//   budgetedFTEs = [],
//   heightValues = 300
// }) => {
//   const data = {
//     labels,
//     datasets: [
//       actualFTEs,
//       budgetedFTEs
//       // {
//       //   label: "Planned",
//       //   data: actualFTEs,
//       //   backgroundColor: "#4CAF50",
//       // },
//       // {
//       //   label: "Actual",
//       //   data: budgetedFTEs,
//       //   backgroundColor: "#2196F3",
//       // },
//     ],
//   };

//   const options = {
//     responsive: true,
//     indexAxis: "y",
//     plugins: {
//       legend: {
//         position: "top",
//         labels: {
//           usePointStyle: true,
//           pointStyle: "circle",
//           boxWidth: 12,
//           boxHeight: 12,
//           padding: 14,
//           font: { size: 12 },
//         },
//       },
//       datalabels: {
//         // color: "#ffffff",
//         // anchor: "center",
//         // align: "center",
//         color: "#000",
//         anchor: "end",
//         align: "right",
//         font: {
//           weight: "bold",
//           size: 12,
//         },
//         // formatter: (value) => value,
//         formatter: (value) => (value > 0 ? value : "")
//       },
//     },
//     scales: {
//       x: {
//         beginAtZero: true,
//         ticks: {
//           display: false,
//         },
//         grid: {
//           display: false,
//         },
//       },
//       y: {
//         stacked: false,
//       },
//     },

//   };

//   return (
//     <Bar data={data} options={options} height={heightValues} />
//   );
// };

// export default HorizontalProgressChart;

// ################# updated ###############
/* eslint-disable */
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

const HorizontalProgressChart = ({
  labels = [],
  actualFTEs = [],
  budgetedFTEs = [],
  heightValues = 300
}) => {
  // Helper function to extract data from dataset
  const extractDataFromDataset = (dataset) => {
    if (!dataset) return [];
    
    // If dataset has a data property
    if (dataset.data && Array.isArray(dataset.data)) {
      return dataset.data;
    }
    
    // If dataset is an array itself
    if (Array.isArray(dataset)) {
      return dataset;
    }
    
    // If it's a dataset object with nested data
    if (dataset.datasets && Array.isArray(dataset.datasets)) {
      return dataset.datasets.flatMap(ds => ds.data || []);
    }
    
    return [];
  };

  // Extract data from both datasets
  const actualData = extractDataFromDataset(actualFTEs);
  const budgetedData = extractDataFromDataset(budgetedFTEs);
  
  // Combine all data points
  const allDataPoints = [...actualData, ...budgetedData]
    .filter(value => !isNaN(value) && value !== null && value !== undefined);

  // Calculate max value from both datasets
  const maxValue = allDataPoints.length > 0 
    ? Math.max(...allDataPoints) 
    : 0;

  // Prepare datasets array
  const datasets = [];
  
  // Add actualFTEs if it exists
  if (actualFTEs && (actualFTEs.data || Array.isArray(actualFTEs) || actualFTEs.label)) {
    datasets.push(actualFTEs);
  }
  
  // Add budgetedFTEs if it exists
  if (budgetedFTEs && (budgetedFTEs.data || Array.isArray(budgetedFTEs) || budgetedFTEs.label)) {
    datasets.push(budgetedFTEs);
  }

  const data = {
    labels,
    datasets,
  };

  const options = {
    responsive: true,
    indexAxis: "y",
    plugins: {
      legend: {
        position: "top",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          boxWidth: 12,
          boxHeight: 12,
          padding: 14,
          font: { size: 12 },
        },
      },
      datalabels: {
        color: "#000",
        anchor: "end",
        align: "right",
        font: {
          weight: "bold",
          size: 12,
        },
        formatter: (value) => (value > 0 ? value : "")
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        suggestedMax: maxValue > 0 ? maxValue * 1.2 : 10, // 20% padding
        ticks: {
          display: false,
        },
        grid: {
          display: false,
        },
      },
      y: {
        ticks: {
          padding: 10,
        },
      },
    },
  };

  return (
    <Bar data={data} options={options} height={heightValues} />
  );
};

export default HorizontalProgressChart;